/**
 * Grant de procesamiento manual de nóminas — sincronizar con smart_back y smart_front.
 *
 * No es un módulo con ruta: controla solo la mutation `processNomina` ("Procesar
 * Manualmente" / "Reprocesar Manualmente" en /pago_proveedores). Default-DENY para
 * roles externos (USER_SMARTCFO) y default-ALLOW para el equipo interno.
 * En el admin se edita en Permisos de Funciones.
 */
export const PROCESAR_NOMINA_MANUAL_MODULE_ID = 'procesar_nomina_manual'

export const NOMINA_GRANT_MODULE_IDS = [PROCESAR_NOMINA_MANUAL_MODULE_ID]

export const NOMINA_GRANT_LABELS = {
  [PROCESAR_NOMINA_MANUAL_MODULE_ID]: 'Procesar Nómina Manualmente',
}

/** Features del modal Permisos de Funciones (storage: modulePermissions). */
export const NOMINA_GRANT_FEATURES = [
  {
    id: PROCESAR_NOMINA_MANUAL_MODULE_ID,
    moduleGrant: true,
    label: 'Procesar Nómina Manualmente',
    description:
      'Permite informar manualmente los pagos de una nómina como aceptados/rechazados y cerrarla (mutation processNomina). Por defecto denegado a usuarios externos; el equipo interno lo tiene activo.',
    items: [
      'Procesar Manualmente una nómina en proceso',
      'Reprocesar Manualmente una nómina ya procesada',
    ],
  },
]

export function isNominaGrantModule(moduleId) {
  return NOMINA_GRANT_MODULE_IDS.includes(moduleId)
}
